/**
 * The agent-harness base URL — the ONE place the SPA reads
 * `VITE_HARNESS_BASE_URL` (T-20260927-6). `http://localhost:8080` in dev.
 *
 * Deliberately a dependency-free leaf: `src/types/plugin-schema.ts` imports it
 * directly and is also loaded by the Node build script
 * `scripts/validate-plugin-manifests.ts`, which must not pull in `client.ts`
 * (axios / sonner / localStorage). Everything else imports the re-export from
 * `@/lib/api/client`. The `typeof import.meta` guard keeps it safe outside Vite.
 *
 * `||`, not `??`: an empty string falls back too. Deploys set the variable at
 * build time.
 */
export const HARNESS_BASE_URL: string =
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_HARNESS_BASE_URL) ||
  'http://localhost:8080';
